<template>
    <div class="conten">
		<div class="nTop" id="toTop" style="background-color:#FFF;">
			<div class="wrapper clearfix">
				<a class="logo"><img src="../assets/images/logo.jpg" alt="佰吉宏安国际能源有限公司"><h1>佰吉宏安国际能源有限公司</h1></a>
				<a class="nt-link" @click="yanzheng('/main')"><img src="../assets/images/ico01.png"> <span>个人中心</span></a>
			</div>
		</div>
		<!-- 导航 -->
		<div class="header">
			<div class="wrapper clearfix">
				<div class="nav clearfix">
					<!-- <router-link  to="/about">关于我们</router-link> -->
					<a @click="tabIndex(1,'/home')" :class="keyIndex == 1 ? 'active' : ''">首页</a>
					<a @click="tabIndex(2,'/about')" :class="keyIndex == 2 ? 'active' : ''">关于我们</a>
					<a @click="tabIndex(3,'/honor')" :class="keyIndex == 3 ? 'active' : ''">资质荣誉</a>
					<a @click="tabIndex(4,'/product')" :class="keyIndex == 4 ? 'active' : ''">主营产品</a> 
					<a @click="tabIndex(5,'/bidding')" :class="keyIndex == 5 ? 'active' : ''">招标信息</a>
					<a @click="tabIndex(6,'/partner')" :class="keyIndex == 6 ? 'active' : ''">合作伙伴</a>
					<a @click="tabIndex(7,'/news')" :class="keyIndex == 7 ? 'active' : ''">新闻资讯</a>
					<a @click="tabIndex(8,'/contact')" :class="keyIndex == 8 ? 'active' : ''">联系我们</a>
				</div>
				<div class="dl-an clearfix" v-if="isLogin">
					<a @click="toPage('/login')"><img src="../assets/images/ico02.png"> <span>登录</span></a>
					<a @click="toPage('/register')"><img src="../assets/images/ico03.png"> <span>注册</span></a> 
				</div>
			</div>
		</div>
		<!-- <div><router-link  to="/main">个人中心</router-link></div> -->
		<router-view ></router-view>
		<div class="footer">
			<div class="wrapper">
				<div class="f-nav">
					<a @click="tabIndex(1,'/home')">首页</a>
					<a @click="tabIndex(2,'/about')">关于我们</a>
					<a @click="tabIndex(3,'/honor')">资质荣誉</a>
					<a @click="tabIndex(4,'/product')">主营产品</a> 
					<a @click="tabIndex(5,'/bidding')">招标信息</a>
					<a @click="tabIndex(6,'/partner')">合作伙伴</a>
					<a @click="tabIndex(7,'/news')">新闻资讯</a>
					<a @click="tabIndex(8,'/contact')">联系我们</a>
				</div>
				
				<div class="f-box flexbox">
					<img src="../assets/images/logo_foot.png" alt="佰吉宏安国际能源有限公司" class="logo_foot">
					<div class="f-center flexbox33 flexwarp" style="text-align: left;">
						<div class="f-item clearfix"><img src="../assets/images/ico05.png"><p>联系电话：{{footerMassage.mobile}}</p></div>
						<div class="f-item clearfix"><img src="../assets/images/ico06.png"><p>邮政编码：{{footerMassage.postal}}</p></div>
						<div class="f-item clearfix"><img src="../assets/images/ico07.png"><p>访问量：{{footerMassage.pageviews}}</p></div>
						<div class="f-item clearfix"><img src="../assets/images/ico08.png"><p>电子邮箱：{{footerMassage.email}}</p></div>
						<div class="f-item clearfix"><img src="../assets/images/ico09.png"><p>公司地址：{{footerMassage.address}}</p></div>
						<div class="f-item clearfix"><img src="../assets/images/ico10.png"><p>交易量：{{footerMassage.trading_volume}}</p></div>
					</div>
					<div class="qrcode">
						<img :src="footerMassage.image_id5_url" alt="">
						<p>扫一扫了解更多</p>
					</div>
				</div>
				<div class="copyright">
					Copyright  2021 ·版权所有 佰吉宏安国际能源有限公司　　<a  href="https://beian.miit.gov.cn" target="_blank">{{footerMassage.site_icp}}&nbsp;{{footerMassage.site_wabah}} </a><br>
					建议使用1920*1080以上的屏幕分辨率和8.0以上版本的浏览器来访问本站，本站不支持IE浏览器
				</div>
			</div>
		</div>
		
		<!-- 右侧浮动 -->
		<div class="floatWindow">
		    <div class="item" @click="toPage('/announcement')">
		        <a class="ico"><img src="../assets/images/a01.png"></a>
		        <p class="txt">公告</p>
		    </div>
		    <div class="item" @click="yanzheng('/main_news')">
				<div class="index_dot" v-if="isRed">
					
				</div>
		        <a class="ico"><img src="../assets/images/a02.png"></a>
		        <p class="txt">消息</p>
		    </div>
			<div class="item"  @click="toPage('/bidding')">
			    <a class="ico"><img src="../assets/images/a03.png"></a>
			    <p class="txt">竞拍</p>
			</div>
			<div class="item">
			    <a class="ico"><img src="../assets/images/a04.png"></a>
			    <p class="txt">{{footerMassage.mobile}}</p>
			</div>
			<div class="item"  @click="toPage('/contact')">
			    <a class="ico"><img src="../assets/images/a05.png"></a>
			    <p class="txt">{{footerMassage.address}}</p>
			</div>
		    <!-- <div class="item">
		        <a href="" target="_blank" class="ico"><img src=""></a>
		    </div> -->
		   <div class="item">
				<a class="ico Top" href="#toTop"><img src="../assets/images/a06.png"></a>
			</div>
		</div>
    </div>
</template>

<script>
import Utils from '../utils/utils.js';
export default {
    name: 'index',
    data() {
        return {
            userInfo:'',//用户信息
            isCollapse: false,
            sidebarMenus:[],
            footerMassage:'',
			keyIndex:1,
			isLogin:true,
			isRed:false
        };
    },
    mounted() {
		// this.$setStorage('keyIndex',this.keyIndex)
		// this.$setStorage('lastKeyIndex',this.keyIndex)
        this.toPage("/home");
        this.site_info()
		this.getRed()
		 var that = this;
		Utils.$on('getRed', function (msg) {
			that.getRed();
		})
    },
	
    methods: {
		
		async getRed() {
			var _this = this
			if(!this.$getStorage('userToken')) return
		    let { status, message, data } = await this.$ajax('no_read_information', {
				userToken: this.$getStorage('userToken'),
		    });
		    if (status == this.SUCCESS_CODE) {
					if(data == 0){
						_this.isRed = false
					}else{
						_this.isRed = true
					}
		    } else {
		        this.$message(message);
		    }
		},
		yanzheng(str){
			var _this = this
			if(this.$getStorage('userToken')){
				_this.toPage(str)
			}else{
				_this.$message({
				  message: '请先登录',
				  type: 'warning'
				});
				_this.toPage('/login')
			}
			
		},
		tabIndex(index,str){
			// this.keyIndex = index
			// window.sessionStorage.setItem('keyIndex', index);
			// this.$setStorage('lastKeyIndex',index)
			// this.$setStorage('keyIndex',index)
			
			this.$router.push({
				path: str
			});
		},
        //底部导航信息
        async site_info(idnex) {
            this.timeIndex = idnex;
			if(this.$getStorage('userToken')){
				this.isLogin = false
			}else{
				this.isLogin = true
			}
            let { status, message, data } = await this.$ajax('site_info', {
            });
            if (status == this.SUCCESS_CODE) {
                
              this.footerMassage = data
            } else {
                this.$message(message);
            }
        },
        
		toPage(pathName, title){
			this.$router.push({
				path: pathName,
				query: { pageTitle: title }
			});
		}
	}
};
</script>

<style>
	
		/* 标题 */
		.n-titBox{margin-bottom: 35px;}
		.n-titBox .ntLeft{float: left;color: #333333;font-weight: bold;}
		.n-titBox .ntRigth{float: right;padding-top: 65px;}
		.n-titBox .ftitle{font-size: 72px;text-transform: uppercase;line-height: 95px;}
		.n-titBox .ftitle em{display: inline-block;width: 15px;height: 15px;background: #af2f24;margin-left: 55px;}
		.n-titBox .title{font-size: 36px;line-height: 70px;}
		.n-titBox .n-more{display: block;width: 120px;height: 42px;border: 1px solid #af2f24;border-radius: 42px;text-align: center;line-height: 40px;font-size: 18px;color: #af2f24;text-transform: uppercase;transition: .5s;}
		.n-titBox .n-more:hover{background: #af2f24;color: #fff;}
		
		
		/* 首页 招聘信息 */
		.n-bidding{padding: 75px 0 85px;color: #333333;}
		.n-bidding .tp{width: 46.25%;float: left;transition: .5s;}
		.n-bidding .tp img{display: block;width: 100%;}
		.n-bidding .cont{width: 47.5%;float: right;line-height: 1.4;padding-top: 20px;}
		.n-bidding .tit{font-size: 32px;}
		.n-bidding .nb-text{font-size: 22px;margin-top: 15px;}
		.n-bidding .nb-text .txt{color: #999999;width: 90px;text-align-last: justify;display: inline-block;vertical-align: top;}
		.n-bidding .nb-text .txt1{width: calc(100% - 100px);display: inline-block;padding-left: 20px;vertical-align: top;}
		.n-bidding .nb-text b{font-size: 34px;}
		.n-bidding .nb-text b,.n-bidding .nb-text small{color: #af2f24;}
		.n-bidding .nb-text:nth-child(2) .txt,.n-bidding .nb-text:nth-child(2) .txt1{vertical-align: bottom;}
		.n-bidding .gd{display: block;width: 260px;height: 50px;background: #af2f24;border-radius: 5px;text-align: center;line-height: 50px;font-size: 22px;margin-top: 45px;color: #fff;transition: .5s;}
		.n-bidding .tp:hover{box-shadow: 5px 5px 5px rgba(0,0,0,.3);-webkit-transform: translateY(-5px);-moz-transform: translateY(-5px);-ms-transform: translateY(-5px);-o-transform: translateY(-5px);transform: translateY(-5px);}
		.n-bidding .gd:hover{box-shadow: 3px 3px 3px #af2f24;-webkit-transform: translateY(-3px);-moz-transform: translateY(-3px);-ms-transform: translateY(-3px);-o-transform: translateY(-3px);transform: translateY(-3px);}
		@media screen and (max-width: 1600px) {
			.n-bidding .cont{padding-top: 15px;}
			.n-bidding .tit{font-size: 28px;}
			.n-bidding .nb-text{font-size: 18px;margin-top: 10px;}
			.n-bidding .nb-text b{font-size: 32px;}
			.n-bidding .gd{width: 220px;height: 40px;line-height: 40px;font-size: 18px;margin-top: 30px;}
		}
		
		
		/* 首页 主营产品 */
		.n-product{width: 100%;padding: 75px 0 110px;background: url(../assets/../assets/images/bj01.jpg) center bottom no-repeat;overflow: hidden;}
		.n-product .p-nav{float: left;font-size: 18px;color: #666666;font-weight: bold;line-height: 38px;margin-right: 65px;position: relative;transition: .5s;}
		.n-product .p-nav:after{content: '';display: block;width: 0;height: 2px;margin: 0 auto;background: #af2f24;position: absolute;bottom: -2px;left: 0;right: 0;transition: .5s;}
		.n-product .p-nav:hover{color: #af2f24;}
		.n-product .p-nav:hover:after{width: 95%;}
		.n-product .p-link{display: block;height: 40px;float: left;line-height: 35px;}
		.n-product .p-link img{width: 100%;}
		.n-product .p-box{width: 91.667vw;}
		.n-product .list{width: 434px;height: 551px;float: left;margin-right: 50px;position: relative;}
		.n-product .list a{display: block;width: 100%;height: 100%;}
		.n-product .list .img{display: block;width: 100%;min-height: 100%;}
		.n-product .list .cont{background: rgba(0,0,0,.6);position: absolute;left: 0;right: 0;bottom: 0;height: 150px;color: #fff;padding: 45px 30px 0;transition: .5s;}
		.n-product .list em{display: block;width: 50px;height: 2px;background: #ffcfb0;margin-bottom: 15px;}
		.n-product .list .tit{font-size: 24px;line-height: 35px;padding-right: 80px;}
		.n-product .list:hover .cont{background: rgba(126,10,0,.6);}
		@media screen and (max-width: 1600px) {
			.n-product .p-nav{margin-right: 45px;}
			.n-product .list{width: 350px;height: 445px;}
			.n-product .list .cont{height: 120px;padding: 30px 20px 0;}
			.n-product .list em{width: 35px;}
			.n-product .list .tit{font-size: 20px;line-height: 30px;}
		}
		@media screen and (max-width: 1440px) {
			.n-product .p-box{width: calc( (100vw - 1200px) / 2 + 1200px );}
		}
		@media screen and (max-width: 1280px) {
			.n-product .p-box{width: calc( (1280 - 1200px) / 2 + 1200px );}
		}
		
		
		/* 首页 关于我们 */
		.n-about{width: 100%;overflow: hidden;position: relative;}
		.n-about .img{width: 51.042%;height: 940px;}
		.n-about .cont{width: 67.448%;height: 715px;background: url(../assets/../assets/images/bj02.jpg) center bottom no-repeat #fff;background-size: 100%;margin: auto 0;position: absolute;top: 0;bottom: 0;right: 0;padding: 75px 7.813% 0;box-shadow: 0 0 15px rgba(0,0,0,.1);overflow: hidden;}
		.n-about .cont article{font-size: 16px;text-align: justify;line-height: 30px;color: #333333;margin-bottom: 90px;}
		.n-about .cont .gd{display: block;width: 42px;}
		.n-about .cont .gd img{display: block;width: 100%;}
		
		
		/* 首页 中标结果  公告 */
		.n-one{width: 100%;background: #edeff5;padding: 110px 0;}
		.n-one .wrapper{width: 88.021%;min-width: 1200px;background: #fff;padding: 30px 0;position: relative;box-shadow: 0 0 15px rgba(0,0,0,.1);}
		
		.n-titBox1{height: 35px;border-left: 8px solid #af2f24;padding-left: 20px;line-height: 35px;margin-bottom: 40px;}
		.n-titBox1 h3{font-size: 32px;}
		.n-titBox1 small{font-size: 26px;color: #b5b5b5;text-transform: uppercase;display: inline-block;margin-left: 18px;}
		
		.n-winBidding{width: 69.031%;height: 650px;padding: 25px 35px;border-right: 1px solid #d5d5d5;float: left;}
		/* .n-winBidding table,.n-winBidding table tr,.n-winBidding table th,.n-winBidding table td{border: 0;} */
		.n-winBidding table{font-size: 18px;color: #333333;text-align: center;}
		.n-winBidding table th{background: #af2f24;color: #fff;font-weight: initial;}
		.n-winBidding table tr{cursor: default;line-height: 30px;transition: .5s;}
		.n-winBidding table th{padding: 11px 0;}
		.n-winBidding table td{padding: 20px 0 4px;}
		.n-winBidding table tr:hover{color: #af2f24;}
		
		.n-announcement{width: 30.969%;height: 650px;padding: 25px 35px;float: right;}
		.n-announcement .list{display: block;height: 54px;font-size: 18px;color: #333333;line-height: 54px;transition: .5s;}
		.n-announcement .list .tit{width: calc(100% - 108px);float: left;padding-left: 18px;background: url(../assets/../assets/images/ico12.png) left center no-repeat;}
		.n-announcement .list time{float: right;display: block;}
		.n-announcement .list:hover{color: #af2f24;}
		
		@media screen and (max-width: 1440px) {
			.n-announcement .list .tit{width: calc(100% - 80px);}
		}
		
		
		/* 首页 新闻资讯 */
		.n-news{width: 100%;padding: 75px 0 85px;}
		.n-news .lNav{width: 200px;position: relative;padding-bottom: 100px;}
		.n-news .lNav a{display: block;font-size: 20px;color: #999999;line-height: 45px;transition: .5s;}
		.n-news .lNav a.qb{color: #333333;position: absolute;bottom: 0;}
		.n-news .lNav a:hover,.n-news .lNav a.active{color: #af2f24;font-weight: bold;}
		.n-news .rBox{width: calc(100% - 200px);}
		.n-news .list{width: 28%;float: left;margin-left: 5.333%;}
		.n-news .list a{display: block;width: 100%;color: #999999;font-size: 14px;transiiton: .5s;}
		.n-news .list .pic{width: 100%;height: 14.063vw;}
		.n-news .list .ly{font-size: 18px;height: 50px;line-height: 50px;margin-top: 10px;}
		.n-news .list .tit{font-size: 22px;color: #333333;font-weight: bold;line-height: 35px;}
		.n-news .list .desc{line-height: 30px;height: 60px;margin: 10px 0 40px;}
		.n-news .list .time{border-top: 1px solid #e8e8e8;height: 76px;line-height: 75px;font-size: 18px;}
		.n-news .list .time span{float: right;}
		.n-news .list:hover a,.n-news .list:hover .tit{color: #af2f24;}
		.n-news .list:hover .time{border-color: #af2f24;}
		
		@media screen and (max-width: 1280px) {
			.n-news .list .pic{height: 192px;}
			.n-news .list .ly{height: 40px;line-height: 40px;}
			.n-news .list .desc{margin-bottom: 30px;}
			.n-news .list .time{height: 66px;line-height: 65px;}
		}
		
		
		/* 首页 合作伙伴 */
		.n-partner{width: 100%;background: url(../assets/../assets/images/bj03.jpg) center center no-repeat;padding: 85px 0 65px;}
		.n-partner .pic{width: 17.5%;height: 153px;background: #fff;border-radius: 5px;float: left;margin-right: 3.125%;transition: .5s;}
		.n-partner .pic:nth-child(5n){margin-right: 0;}
		.n-partner .pic img{min-height: auto;}
		.n-partner .pic:hover,.n-partner .pic.active{box-shadow: 0 0 10px rgba(0,0,0,.1);}
		.n-partner .btn{margin: 70px auto 0;width: 110px;}
		.n-partner .btn .an{width: 17px;cursor: pointer;}
		.n-partner .btn .an img{display: block;width: 100%;}
		.n-partner .btn .prev{float: left;}
		.n-partner .btn .next{float: right;}
		@media screen and (max-width: 1440px) {
			.n-partner .pic{height: 120px;}
		}
		.index_dot{
			width: 10px;
			height: 10px;
			position: absolute;
			right: 5px;
			top: 5px;
			border-radius: 50%;
			background-color: #af2f24;
		}
</style>




// WEBPACK FOOTER //
// src/views/index.vue